import {Injectable} from '@angular/core';
import {Headers} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Router} from '@angular/router';

import {CustomHttp} from '../shared/custom.http';
import {Title} from './model/title';

@Injectable()
export class TitleService {
    private titlesUrl = '/tms/contentTitle';

    constructor(private router: Router, private http: CustomHttp) {
    }

    getTitles() {
        return this.http.get(this.titlesUrl);
    }

    createTitle(title: Title) {
        return this.http.post(this.titlesUrl, title);
    }

    deleteTitle(title: Title) {
        const url = `${this.titlesUrl}?contentId=${title.content_id}`;
        return this.http.delete(url, {body: ''});
    }

    updateTitle(title: Title, currentUserId: string) {
        const url = `${this.titlesUrl}?contentId=${title.content_id}&currentUserId=${currentUserId}`;
        return this.http.put(url, title);
    }

    getTitle(content_id: string) {
        const url = `${this.titlesUrl}?contentId=${content_id}`;
        return this.http.get(url, {body: ''});
    }
}



// WEBPACK FOOTER //
// ./src/app/tms/title.service.ts